module.exports = __webpack_public_path__ + "static/media/homeBackgroundLow.cd1892b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/homeBackgroundLow.jpg
// module id = 328
// module chunks = 0